import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';

export const mockEmptyLoggedOutUser: MockResponseConfig = {
  UnifiedSystemMutation: (variables: Variables) => ({
    data: {
      unified: {
        createUnifiedSystem: {
          errors: [],
          success: true,
          unifiedProfile: {
            bio: '',
            company: '',
            aaid: '62587f99fdb60b0069294184',
            id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
            linkedinUrl: '',
            location: '',
            accountInternalId: '541b9286-8563-4825-aae8-43e7e90fb493',
            products: null,
            role: '',
            internalId: 'c34de571-576f-45e6-8c02-0917609af889',
            username: 'emptyloggedout',
            websiteUrl: '',
            xUrl: null,
            youtubeUrl: null,
            isPrivate: false,
            isPersonalView: false,
            isLinkedView: false,
          },
        },
      },
    },
  }),
  UnifiedProfileQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          bio: '',
          company: '',
          aaid: '62587f99fdb60b0069294184',
          linkedinUrl: '',
          accountInternalId: '541b9286-8563-4825-aae8-43e7e90fb493',
          location: '',
          products: null,
          role: '',
          internalId: 'c34de571-576f-45e6-8c02-0917609af889',
          username: 'emptyloggedout',
          websiteUrl: '',
          xUrl: '',
          youtubeUrl: '',
          isPrivate: false,
          isPersonalView: false,
          isLinkedView: false,
        },
      },
    },
  }),
  AtlassianAccountUserQuery: (variables: Variables) => ({
    data: {
      me: {},
    },
  }),
  AtlassianAccountAnyUserQuery: (variables: Variables) => ({
    data: {
      user: {
        __typename: 'AtlassianAccountUser',
        nickname: 'Empty User',
        picture: 'http://www.google.com/initials',
        id: 'ari:cloud:identity::user/62587f99fdb60b0069294184',
      },
    },
  }),
  KudosSummaryQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          gamification: {
            __typename: 'UnifiedGamification',
            id: 'ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184',
            recognitionsSummary: {
              __typename: 'UnifiedGamificationRecognitionsSummary',
              id: 'ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/recognition-summary',
              totals: [
                {
                  comment: 'for writing great content',
                  count: 0,
                },
                {
                  comment: 'just because',
                  count: 0,
                },
                {
                  comment: 'for going above and beyond',
                  count: 0,
                },
                {
                  comment: 'for being awesome at an ace',
                  count: 0,
                },
              ],
            },
            levels: {
              __typename: 'UnifiedGamificationLevel',
              id: 'ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/level',
              currentLevelArt:
                'https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/level_icon-752347?1602275472120',
              currentLevelDescription: 'Level 1',
              currentLevelName: 'Seed',
              currentPoints: 0,
              maxPoints: 150,
              nextLevelName: 'Root',
            },
          },
        },
      },
    },
  }),
  StatsSnapshotQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          forums: {
            __typename: 'UnifiedForums',
            id: 'ari:cloud:unified-portable-profile::forums/723',
            snapshot: {
              __typename: 'UnifiedForumsSnapshot',
              id: 'ari:cloud:unified-portable-profile::forums/723/snapshot',
              acceptedAnswersCreated: 0,
              answersCreated: 0,
              articlesCreated: 0,
              kudosReceived: 0,
              totalPosts: 0,
            },
          },
        },
      },
    },
  }),
  UnifiedLearningCertificationQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          learning: {
            __typename: 'UnifiedLearning',
            certifications: {
              __typename: 'UnifiedLearningCertificationConnection',
              edges: [],
              totalCount: 0,
            },
          },
        },
      },
    },
  }),
  UnifiedForumsGroupsQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          forums: {
            __typename: 'UnifiedForums',
            id: 'ari:cloud:unified-portable-profile::forums/723',
            groups: {
              __typename: 'UnifiedForumsGroupsConnection',
              edges: [],
              totalCount: 0,
            },
          },
        },
      },
    },
  }),
  ProfileBadgesQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          aaid: '62587f99fdb60b0069294184',
          learning: {
            __typename: 'UnifiedLearning',
            id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184',
            recentCoursesBadges: {
              __typename: 'UnifiedProfileBadgesConnection',
              edges: [],
              totalCount: 0,
            },
          },
          badges: {
            __typename: 'UnifiedProfileBadgesConnection',
            edges: [],
            pageInfo: {
              endCursor: '0',
              hasNextPage: false,
              hasPreviousPage: false,
              startCursor: '0',
            },
            totalCount: 0,
          },
        },
      },
    },
  }),
};
